export const actions = {
  setTime: 'SET::SETTIME',
  get: 'GET::GETTIME'
}

export const setTaskTime = taskTimeSelected => ({ type: actions.setTime, taskTimeSelected })
export const getTaskTime = state => state.taskTime.taskTimeSelected

export default actions
